import React from 'react'
import {injectIntl} from 'react-intl'
import {connect} from 'react-redux'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Dialog from 'components/Dialog'
import Signature from './Signature'
import {updateSignature, deleteSignature, createSignature} from 'modules/email/actions'

class SignatureDialog extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            value: props.data ? props.data.value : null,
            create: false
        }
    }

    handleDelete = () => {
        this.props.handleEditorUpdate(this.props.id)
        this.props.handleClose()
    }

    handleEdit = () => {
        const obj = {
            value: this.state.value
        }

        if (this.props.data) {
            this.props.handleEditorUpdate(this.props.id, obj)
        } else {
            this.props.insertBlock(this.props.type, obj)
        }

        this.props.handleClose()
    }

    handleCreate = () => {
        this.setState({create: true})
    }

    handleCancel = () => {
        this.setState({create: false})
    }

    handleChange = (id) => {
        this.setState({
            value: id
        })
    }

    updateSignature = (obj) => {
        this.props.updateSignature(obj, this.props.application)
    }

    deleteSignature = (id) => {
        this.props.deleteSignature(id, this.props.application)
    }

    createSignature = (obj) => {
        this.props.createSignature(obj, this.props.application)
        this.setState({create: false})
    }

    render() {
        const {intl} = this.props
        const signatures = this.props.signatures ? this.props.signatures[this.props.application] : null

        return (
            <Dialog open={this.props.open} onClose={this.props.handleClose}>
                <DialogTitle>
                    {intl.formatMessage({id: "editor.sign_settings"})}
                </DialogTitle>
                <DialogContent>
                    {!!signatures && !!signatures.length ?
                        <React.Fragment>
                            {signatures.map(item =>
                                <Signature
                                    key={item.id}
                                    handleSelect={this.handleChange}
                                    data={item}
                                    active={item.id === Number(this.state.value)}
                                    updateSignature={this.updateSignature}
                                    deleteSignature={this.deleteSignature}
                                />
                            )}
                        </React.Fragment> :
                        !this.state.create && <div>{intl.formatMessage({id: "editor.have_no_signatures"})}</div>
                    }
                    {this.state.create &&
                        <Signature
                            createSignature={this.createSignature}
                            handleCancel={this.handleCancel}
                            create
                        />
                    }
                    <Button
						variant="contained"
                        onClick={this.handleCreate}
                        disabled={this.state.create}
                        style={{background: '#4cae4c', color: '#FFF', marginTop: '20px'}}
                    >
                        {intl.formatMessage({id: "editor.create_signature"})}
                    </Button>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    {this.props.data &&
                        <Button onClick={this.handleDelete}
                            variant="contained"
                            color="secondary"
                        >
                            {intl.formatMessage({id: "app.confirm_delete"})}
                        </Button>
                    }
                    <Button onClick={this.handleEdit} disabled={!this.state.value} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_save"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = ({email, applications}) => ({
    signatures: email.signatures,
    application: applications.current
})

export default connect(mapStateToProps, {updateSignature, deleteSignature, createSignature})(injectIntl(SignatureDialog))
